import { Box, Button, Grid, Tooltip, Typography } from "@material-ui/core";
import API from 'util/onboardApi'
import liveLocation from 'assets/images/live-loaction.png'
import carETA from 'assets/images/car.png'
import person from 'assets/images/user.png'
import clock from 'assets/images/clock.png'
import { LinearProgress as LinearProgres } from "@material-ui/core";
import SnackBar from 'components/SnackBar'
import React, { useEffect, useState } from "react";
import { Formik,Form } from 'formik'
import CardBox from 'components/CardBox'
import FormFilter from "components/FormFilter";
import LocationsTable from "components/ActionsTable/Locationstable";


const OnboardingUsers = (props) => {

    const summary = [{item:'Total Locations', count: 124},{item:'Cars Retrived', count: 58},{item:'Avg Retrival Time', count: '7 mins'},{item:'Total Partners', count: '1,200'}]
    const [config, setConfig] = useState();
    const [user, setUser] = useState();
    const [loading, setLoading] = useState();
    const [showPending, setShowPending] = useState(false);
    const [locationsList, setLocationsList] = useState({
        title: 'Locations',
        headers: ['Name','Total Valets', 'Full Time', 'On Demand', 'Actions'],
        body : [{
            name: {
                disabled: false,
                hidden: false,
                title: 'Name',
                type: 'input',
                value: 'Location 1',
                key: 'name'
            },
            total_valets: {
                disabled: false,
                hidden: false,
                title: 'Total Valets',
                type: 'input',
                value: '123',
                key: 'total_valets'
            },
            full_time: {
                disabled: false,
                hidden: false,
                title: 'Full Time',
                type: 'input',
                value: 10,
                key: 'full_time'
            },
            on_demand: {
                disabled: false,
                hidden: false,
                title: 'On Demand',
                type: 'input',
                value: '10',
                key: 'on_demand'
            },
            on_demand_present: {
                disabled: false,
                hidden: false,
                title: 'on_demand_present',
                type: 'input',
                value: '7',
                key: 'on_demand_present'
            },
            on_demand_absent: {
                disabled: false,
                hidden: false,
                title: 'on_demand_absent',
                type: 'input',
                value: '7',
                key: 'on_demand_absent'
            },
            full_time_present: {
                disabled: false,
                hidden: false,
                title: 'full_time_present',
                type: 'input',
                value: '7',
                key: 'full_time_present'
            },
            full_time_absent: {
                disabled: false,
                hidden: false,
                title: 'full_time_absent',
                type: 'input',
                value: '7',
                key: 'full_time_absent'
            }

        },
        {
            name: {
                disabled: false,
                hidden: false,
                title: 'Name',
                type: 'input',
                value: 'Location 2',
                key: 'name'
            },
            total_valets: {
                disabled: false,
                hidden: false,
                title: 'Total Valets',
                type: 'input',
                value: 54,
                key: 'total_valets'
            },
            full_time: {
                disabled: false,
                hidden: false,
                title: 'Full Time',
                type: 'input',
                value: 56,
                key: 'full_time'
            },
            on_demand: {
                disabled: false,
                hidden: false,
                title: 'On Demand',
                type: 'input',
                value: 12,
                key: 'on_demand'
            },
            on_demand_present: {
                disabled: false,
                hidden: false,
                title: 'on_demand_present',
                type: 'input',
                value: 34,
                key: 'on_demand_present'
            },
            on_demand_absent: {
                disabled: false,
                hidden: false,
                title: 'on_demand_absent',
                type: 'input',
                value: 2,
                key: 'on_demand_absent'
            },
            full_time_present: {
                disabled: false,
                hidden: false,
                title: 'full_time_present',
                type: 'input',
                value: 25,
                key: 'full_time_present'
            },
            full_time_absent: {
                disabled: false,
                hidden: false,
                title: 'full_time_absent',
                type: 'input',
                value: 4,
                key: 'full_time_absent'
            }

        }]

    });
    const [initialValues, setInitialValues] = useState();
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });


    useEffect(()=>{
        getLocationsList();
        const query = new URLSearchParams(props.location.search);
        const type = query.get('type');
        if(type)setShowPending(true)
    },[])


    const getLocationsList = ()=>{
        setLoading(true);
        API.get("onboardingUsers")
        .then((res) => {
            setConfig(Object.values(res.data.data.config.fields))
            // setLocationsList(res.data.data.users);
            setInitialValues(res.data.data.users);
            setUser(null)
        })
        .catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })
        }).finally(()=>{
            setLoading(false)
        })
    }
    const onSubmit = ()=>{
    }
    const onReset = ()=>{}
    const onEdit = ()=>{
        window.open(`location-users`, '_blank');
    }

    const handleOnDemand = ()=>{
        props.history.push('/app/job/job-list')
    }
    return(
        <div>
            {/* <ContainerHeader title={"Overview"} match={props.match} /> */}

            <div className="row align-items-center w-100 justify-content-between pl-2">
                <img src="/VRO-Black.webp" style={{width:'120px'}}/>
                <Box mr="10px" display="inline"><Button disabled={showPending} variant="contained" color="primary" mr="5px" type="submit" onClick={handleOnDemand}> Valet On-Demand</Button>{ showPending &&  <Typography style={{fontSize:'12px'}} className='card-header-title text-black'>Job Waiting for approval</Typography>}</Box>
                
            </div> 
            <div className="row row justify-content-start col-12 mt-5 p-0">
                {
                    summary?.map((item, index) => (
                        <div className="col-xl-3 col-lg-auto col-md-10 col-sm-10 ">
                            <div style={{ borderRadius: "10px" }} className={`jr-card p-0 overflow-hidden card-entire-box${index + 1}`}>
                                <div className='card-designer'></div>
                                <div className={`row m-0 card-body box${index + 1}`}>
                                    <div className={`rounded-container-parent card-entire-box${index + 1}`}>
                                        <div className='rounded'>
                                            <img className='rounded-image' alt='' src={ index === 0 ? liveLocation : index === 1 ? carETA : index === 2 ? clock : person} />
                                            {/* <CheckIcon className="headericons" /> */}
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-flex-start justify-content-center flex-column w-50 ml-2'>
                                        <Typography variant='h6' className='card-header-title text-white'>{item?.item}</Typography>
                                        <Typography variant='h5' className='text-white' style={{ fontSize: '1.8rem' }}>{item?.count}</Typography>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))
                }
                <Grid item className="row row justify-content-between col-12 mt-1 " style={{ borderRadius: 10 }}  >
                    {/* BIKE PAYMENT MODE */}
                    <Grid container  direction="column" className="paymentModeContainer col-md-5 col-sm-12 mt-sm-5 p-0 pt-1">
                        <Grid container className="paymentModeHeader" style={{borderRadius:'10px'}}>
                            <Grid item style={{ fontSize: '1.5rem' }} className="d-flex align-items-center">
                                {/* <VehicleIcon type={modes.title} />
                                {modes.title.toUpperCase()} */}
                                Full Time Partners
                            </Grid>
                            <Grid container direction="row" className="paymentModeHeaderContent mt-1 col-12 " spacing={2}>
                                <Tooltip title="Total Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>10</div></div>
                                            <div> Total </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                                <Tooltip title="Total Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>4</div></div>
                                            <div> Present </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                                <Tooltip title="Avilable Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>4</div></div>
                                            <div> Absent </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" className="paymentModeContainer col-md-5 col-sm-12 mt-sm-5 p-0 pt-1">
                        <Grid container className="paymentModeHeader" style={{borderRadius:'10px'}}>
                            <Grid item style={{ fontSize: '1.5rem' }} className="d-flex align-items-center">
                                {/* <VehicleIcon type={modes.title} />
                                {modes.title.toUpperCase()} */}
                                On Demand Partners
                            </Grid>
                            <Grid container direction="row" className="paymentModeHeaderContent mt-1 col-12" spacing={2}>
                                <Tooltip title="Total Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>10</div></div>
                                            <div> Total </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                                <Tooltip title="Total Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>4</div></div>
                                            <div> Present </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                                <Tooltip title="Avilable Slots">
                                    <Grid item xs={12} sm={6} md={4} >
                                        <div className="d-flex align-items-end flex-column" style={{ maxWidth: 'max-content' }}>
                                            <div className="d-flex align-items-center"><div style={{ padding: '10px 0px 6px 0px', fontSize: '1.5rem' }}>4</div></div>
                                            <div> Absent </div>
                                        </div>
                                    </Grid>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
             {
                    config &&
                    <div className="mt-5 w-100">
                        <Formik
                            onSubmit={onSubmit}
                            onReset={onReset}
                            initialValues={initialValues}
                            enableReinitialize
                            // validationSchema={}
                        >
                            <Form>
                                <CardBox styleName="col-12">
                                    <FormFilter 
                                        locations={[]}
                                        onFormSubmit={onSubmit}
                                        formSubmitText={'Get Details'}
                                        flags = {{
                                            "location": false,
                                            "type": false,
                                            "noMinDate": true,
                                            "showDate": true,
                                            "amount":false,
                                            "reason":false,
                                            "clients":false,
                                            "selectDate":false,
                                            "jobs": false,
                                            "date": false,
                                            "jobLocation": false,
                                            "multiLocation": false,
                                            "resetForm" : true
                                        }}
                                    />
                                </CardBox>
                                {locationsList &&
                                    <LocationsTable data={locationsList.body} onEdit={onEdit} getLocationsList={getLocationsList} />
                                }
                            </Form>
                        </Formik> 
                    </div>  
                    } 
            </div>
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        </div>
        
    )
}
export default OnboardingUsers;